import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("ai_hub_user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("ai_hub_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => {
        setUser(res.data);
        localStorage.setItem("ai_hub_user", JSON.stringify(res.data));
      })
      .catch(() => {
        localStorage.removeItem("ai_hub_token");
        localStorage.removeItem("ai_hub_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const persist = (token, u) => {
    if (token) localStorage.setItem("ai_hub_token", token);
    if (u) localStorage.setItem("ai_hub_user", JSON.stringify(u));
    if (u) setUser(u);
  };

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    persist(res.data.access_token, res.data.user);
    return res.data.user;
  };

  const register = async (form) => {
    const res = await api.post("/auth/register", form);
    persist(res.data.access_token, res.data.user);
    return res.data.user;
  };

  const forgotPassword = async (email, message) => {
    const res = await api.post("/auth/forgot-password", { email, message });
    return res.data;
  };

  const changePassword = async (current_password, new_password) => {
    const res = await api.post("/auth/change-password", {
      current_password,
      new_password,
    });
    persist(res.data.access_token, res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem("ai_hub_token");
    localStorage.removeItem("ai_hub_user");
    setUser(null);
  };

  return (
    <AuthCtx.Provider
      value={{
        user,
        login,
        register,
        forgotPassword,
        changePassword,
        logout,
        loading,
      }}
    >
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
